import styles from './ErrorMessage.module.css';
import { ErrorStatusOutlineSVG } from '../../../svgComponents/errorStatusOutlineSVG';

const ErrorMessage = ({ error }: { error: any }) => {
    return (
        <div className={styles.container}>
            <ErrorStatusOutlineSVG
                data-testid="error-icon"
                className={styles.icon}
                fill="rgba(150, 11, 3, 1)"
                stroke="rgba(150, 11, 3, 1)"
                transform="rotate(180)"
            />
            {error}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default ErrorMessage;
